// extracted by mini-css-extract-plugin
module.exports = {"section":"_1n2ems"};